import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import api from '../utils/api';
import '../styles/Pages.css';

function NewsAndEvents() {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/news').then(r => setNews(r.data)).catch(() => setNews([])).finally(() => setLoading(false));
    }, []);

    const fallback = [
        { title: 'Success Story', date: '2021-03-09', category: 'Achievement', content: 'Student of Shri Mulikadevi Mahavidyalaya achieves remarkable success in competitive examination.' },
        { title: 'College News — ISO Certification', date: '2019-07-20', category: 'College News', content: 'College receives ISO certification for quality management systems.' },
        { title: 'Seed Bank Launch at College', date: '2019-04-24', category: 'Seed Bank', content: 'A unique Seed Bank initiative launched to promote agricultural awareness among students.' },
        { title: 'Utkarsh — College Magazine 2019', date: '2019-04-09', category: 'Magazine', content: '"Utkarsh" — the annual college magazine — was published with contributions from students and faculty.' },
        { title: 'Tree Plantation Drive', date: '2017-08-16', category: 'NSS Activity', content: 'SP Ranjankumar Sharma inaugurated the Competitive Exam Guidance Center and participated in a tree plantation drive.' },
        { title: 'Language Mastery for Goal Achievement', date: '2017-08-14', category: 'Event', content: 'Inauguration of Competitive Examination Guidance Center — SP Rajan Kumar Sharma addressed students.' },
    ];

    const display = (!loading && news.length) ? news : fallback;
    const categories = ['All', ...new Set(display.map(n => n.category))];
    const [filter, setFilter] = useState('All');
    const filtered = filter === 'All' ? display : display.filter(n => n.category === filter);

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › News &amp; Events</p>
                <h1>News &amp; Events</h1>
                <p>Latest happenings, achievements and events from Shri Mulikadevi Mahavidyalaya.</p>
            </div>
            <div className="page-content">
                <div className="tabs-row">
                    {categories.map(c => (
                        <button key={c} className={`tab-btn ${filter === c ? 'active' : ''}`} onClick={() => setFilter(c)}>{c}</button>
                    ))}
                </div>
                {loading ? <p>Loading news…</p> : (
                    <div className="cards-grid">
                        {filtered.map((n, i) => (
                            <div className="grid-card" key={i} style={{ borderLeft: 'none', borderTop: '4px solid #2d6a4f' }}>
                                <div style={{ fontSize: '0.75rem', color: '#999', marginBottom: '0.3rem' }}>
                                    {n.category} &nbsp;|&nbsp; {new Date(n.date || n.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                                </div>
                                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>{n.title}</h3>
                                <p style={{ fontSize: '0.88rem' }}>{n.content?.substring(0, 140)}…</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}
export default NewsAndEvents;
